enum Language {
    ES = "es",
    EN = "en"
}

export default Language;